import $ from "jquery";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from "swiper";

import {
  Pagination,
  Navigation
} from "swiper/modules";

export default class TilesWithIcons {
  constructor($el) {
    const el = $el && $el.get ? $el.get(0) : $el;
    if (!el) return;

    gsap.registerPlugin(ScrollTrigger);
    new TilesWithIconsClass(el);
  }
}

class TilesWithIconsClass {
  
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    let width = window.innerWidth;
    if(width < 768){
      this.initSwiper();
    }
    else{
      //this.setupCardAnimations();
      //this.setupAmplifyAnimation();
    }
  }

  setupCardAnimations() {
    const elId = this.el.attr("id");
    console.log(elId);
    gsap.from("#" + elId + " .tile", {
      y: "+=100",
      opacity: 0,
      duration: 1,
      stagger: 0.2,

      scrollTrigger: {
        trigger: this.$el[0],
        start: "top bottom",
        end: "bottom 90%",
        scrub: 1,
        toggleActions: "play none none none",
        markers: false,
      },
    });
  }

  setupAmplifyAnimation() {
    const svg = this.el.find(".background svg path")[0];

    gsap.to(svg, {
      attr: { d: "M1455,1441 L1458, 50, 0, 350 l8.68,1291 h1446Z" },
      ease: "none",
      scrollTrigger: {
        trigger: this.$el[0],
        start: "top bottom",
        end: "bottom top",
        scrub: 3,
        toggleActions: "play none none none",
        markers: false,
      },
    });
  }

  initSwiper(){
    Swiper.use([
      Navigation
    ]);
    const bullets = this.el.querySelectorAll('.bullet');

    this.carousel = new Swiper(this.el.querySelector('.swiper'), {
      slidesPerView: 1,
      slidesPerGroup:1,
      spaceBetween: -32,
      initialSlide: 1,
      loop:true,
      loopAdditionalSlides: 1,
      loopedSlides: 3,
      navigation: {
        nextEl: this.el.querySelector('.swiper--next'),
        prevEl: this.el.querySelector('.swiper--prev'),
      },
      on: {
        activeIndexChange: function(){
          let index = this.realIndex;
          if(index>2){
            index = (this.realIndex)%3;
          }
          bullets.forEach((bullet, i) => {
            if(i === index){
              bullet.classList.add('swiper-pagination-bullet-active');
            }
            else{
              bullet.classList.remove('swiper-pagination-bullet-active');
            }
          });
        },
      }
    });
  }
}
